const dateOffset = new Date().getTimezoneOffset()
export const dateOffsetString = ` 00:00:00-${Math.floor(dateOffset/60)}:${(dateOffset%60).toString().padStart(2,'0')}`
